export default "__VITE_ASSET__556aad1a__"